/**
 * Pick random elements.
 * @param {Array} arr - array of elements
 * @param {number} n - number of elements to pick
 * @returns a randomly ordered array of `n` randomly chosen elements of `arr`.
 */
function randomSubset(arr, n) {
	if (!(arr instanceof Array)) throw new Error(`Argument ${arr} is not an array`);
	if (n < 0) throw new Error(`Argument ${n} is not a valid number`);
	if(n > arr.length) n = arr.length;
	let temp = [];
	for(let i = 1; i <= n; i++){
		let rand = Math.floor(Math.random() * arr.length);
		while(temp.indexOf(rand) !== -1){
			rand = Math.floor(Math.random() * arr.length);
		}
		temp.push(rand);
	}
	let result = [];
	for(let i = 0; i < temp.length; i++) {
		result.push(arr[temp[i]]);
	}
	return result;
}

module.exports = randomSubset;